/** Refactor routing ok  */
import { RouteName } from "../RouteNames";

export const agendaRoutes = {
  name: RouteName.Agenda,
  path: "agendas",
  component: () => import("@follaw-fr/views/side_menu_views/AgendasView.vue"),
};
